// extracted by mini-css-extract-plugin
export default {"rotateBanner":"VN1Zs","export_game":"gTUd0","iframe":"BqLvg","ad_block":"kzpuu"};